module.exports = __webpack_public_path__ + "static/media/slovakia.b84444bf.svg";